import { registerLocale, setDefaultLocale } from 'react-datepicker';
import { zhCN as dateFnsZhCN } from 'date-fns/locale/zh-CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import moment from 'moment';
import 'moment/locale/zh-cn';

registerLocale('zh-CN', dateFnsZhCN);
setDefaultLocale('zh-CN');
dayjs.locale('zh-cn');
moment.locale('zh-cn');
